class ProductUpsell extends HTMLElement {
    constructor() {
        super();

        this.variantsJSON = JSON.parse(
            this.querySelector("script")?.textContent || "[]"
        );

        this.variantSelector = this.querySelector(
            ".product-upsell__variants--select"
        );

        this.atcButton = this.querySelector(
            ".product-upsell__buttons--atc"
        );

        this.variantId = this.variantSelector
            ? Number(this.variantSelector.value)
            : null;
    }

    connectedCallback() {
        this.attachListeners();

        // Set initial state
        if (this.variantId) {
            const currentVariant = this.variantsJSON.find(
                (variant) => variant.id === this.variantId
            );

            if (currentVariant) {
                this.setAvailableVariant(currentVariant);
                this.setImageVariant(currentVariant);
            }
        }
    }

    attachListeners() {
        this.variantSelector?.addEventListener(
            "change",
            this.handleVariantChange.bind(this)
        );

        this.atcButton?.addEventListener(
            "click",
            this.handleAddToCart.bind(this)
        );
    }

    handleVariantChange() {
        this.variantId = Number(this.variantSelector.value);

        const currentVariant = this.variantsJSON.find(
            (variant) => variant.id === this.variantId
        );

        if (!currentVariant) return;

        this.setAvailableVariant(currentVariant);
        this.setImageVariant(currentVariant);
    }

    async handleAddToCart(event) {
        event.preventDefault();

        if (!this.variantId) return;

        this.atcButton.disabled = true;
        this.atcButton.textContent = "Adding...";

        try {
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
                body: JSON.stringify({
                    id: this.variantId,
                    quantity: 1,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to add product");
            }

            const cartItem = await response.json();
            console.log("Added:", cartItem);

            this.atcButton.textContent = "Added ✓";

            // Optional: Refresh cart drawer if your theme supports it
            document.dispatchEvent(
                new CustomEvent("cart:refresh", {
                    bubbles: true,
                })
            );

            setTimeout(() => {
                this.atcButton.textContent = "Add to Cart";
                this.atcButton.disabled = false;
            }, 1500);
        } catch (error) {
            console.error(error);

            this.atcButton.textContent = "Add to Cart";
            this.atcButton.disabled = false;
        }
    }

    setImageVariant(currentVariant) {
        const image = this.querySelector(
            ".product-upsell__information--image img"
        );

        if (!image || !currentVariant.featured_image) return;

        image.src = currentVariant.featured_image.src;
        image.srcset = currentVariant.featured_image.src;
    }

    setAvailableVariant(currentVariant) {
        if (!currentVariant.available) {
            this.atcButton.disabled = true;
            this.atcButton.textContent = "Sold Out";
            return;
        }

        this.atcButton.disabled = false;
        this.atcButton.textContent = "Add to Cart";
    }
}

customElements.define("dtc-product-upsell", ProductUpsell);
// class ProductUpsell extends HTMLElement {
//     constructor() {
//         super();

//         this.variantsJSON = JSON.parse(this.querySelector('script')?.textContent || '{}');
//         this.variantSelector = this.querySelector('.product-upsell__variants--select');
//         this.atcButton = this.querySelector('.product-upsell__buttons--atc');
//         this.variantId = Number(this.variantSelector.value)
//     }

//     connectedCallback() {
//         this.attachListeners()
//     }

//     attachListeners() {
//         this.variantSelector && this.variantSelector.addEventListener('change', this.handleVariantChange.bind(this))
//         this.atcButton && this.atcButton.addEventListener('click', this.handleAddToCart.bind(this))
//     }

//     handleVariantChange() {
//         const variantId = this.variantSelector.value
//         this.variantId = Number(variantId)

//         const currentVariant = this.variantsJSON.find(variant => variant.id === this.variantId)
//         if (!!!currentVariant) return

//         this.setAvailableVariant(currentVariant)
//         this.setImageVariant(currentVariant)
//     }

//     handleAddToCart(event) {
//         event.preventDefault()
//         this.atcButton.textContent = 'Adding...'

//         addToCart(this.variantId, 1).then(response => {
//             this.atcButton.textContent = 'Add to Cart'
//         })
//         .catch(error => {
//             console.error('Error adding to cart:', error);
//             this.atcButton.textContent = 'Add to Cart'
//         })
//     }

//     setImageVariant(currentVariant) {
//         const image = this.querySelector('.product-upsell__information--image img');
//         if (!!!image) return

//         image.src = currentVariant.featured_image.src
//         image.srcset = currentVariant.featured_image.src
//     }

//     setAvailableVariant(currentVariant) {
//         const isVariantAvailable = currentVariant.available
//         if (!!!isVariantAvailable) {
//             this.atcButton.setAttribute('disabled', '')
//             this.atcButton.textContent = 'Sold Out'

//             return
//         }

//         this.atcButton.removeAttribute('disabled')
//         this.atcButton.textContent = 'Add to Cart'
//     }
// }

// customElements.define('dtc-product-upsell', ProductUpsell);